function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './Ticker.scss';

var ArrowUp = function ArrowUp() {
  return React.createElement(
    'svg',
    { width: '10', height: '4', viewBox: '0 0 10 4', xmlns: 'http://www.w3.org/2000/svg' },
    React.createElement('path', { d: 'M9 4L5 0 1 4', stroke: '#3899EC', fill: 'none', fillRule: 'evenodd' })
  );
};

var Ticker = function Ticker(_ref) {
  var onUp = _ref.onUp,
      onDown = _ref.onDown,
      upDisabled = _ref.upDisabled,
      downDisabled = _ref.downDisabled;

  var upProps = buildProps(styles.up, onUp, upDisabled);
  var downProps = buildProps(styles.down, onDown, downDisabled);
  return React.createElement(
    'div',
    { className: styles.root, 'data-hook': 'ticker' },
    React.createElement(
      'div',
      upProps,
      React.createElement(ArrowUp, null)
    ),
    React.createElement(
      'div',
      downProps,
      React.createElement(ArrowUp, null)
    )
  );
};

Ticker.displayName = 'Input.Ticker';

Ticker.propTypes = {
  onUp: PropTypes.func,
  onDown: PropTypes.func,
  upDisabled: PropTypes.bool,
  downDisabled: PropTypes.bool
};

function buildProps(clazz, onClick, disabled) {
  return {
    className: classnames(clazz, _defineProperty({}, styles.disabled, disabled)),
    onClick: disabled ? null : onClick
  };
}

export default Ticker;
//# sourceMappingURL=Ticker.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Input/Ticker/Ticker.js